<template>
  <v-layout>
    <v-dialog v-model="dialogVisible" max-width="600px" @click:outside="closeDialog">
      <v-card>
        <v-card-title>
          <span class="headline">Cambiar Estado Interno</span>
        </v-card-title>

        <v-card-text>
          <div v-if="loading" class="text-center py-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>

          <div v-else>
            <v-combobox
              v-model="selectedState"
              :items="internal_states"
              item-text="name"
              item-value="id"
              label="Estado Interno*"
              :disabled="saving"
            ></v-combobox>

            <v-textarea
              v-model="observaciones"
              label="Observaciones"
              rows="3"
              :disabled="saving"
              class="mt-3"
            ></v-textarea>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="closeDialog">Cerrar</v-btn>
          <v-btn 
            color="success" 
            text
            @click="confirmChange" 
            :loading="saving"
            :disabled="!selectedState || saving"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { generalService } from "@/libs/ws/generalService";
import { productionOrderService } from "@/libs/ws/productionOrderService";
import ConstantSections from "@/constants/sections";

export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    productionOrder: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dialogVisible: false,
      internal_states: [],
      selectedState: null,
      observaciones: null,
      loading: false,
      saving: false,
    };
  },
  watch: {
    dialog(val) {
      this.dialogVisible = val;
      if (val) {
        this.loadInternalStates();
        this.selectedState = this.productionOrder?.internal_state || null;
        this.observaciones = null;
      }
    },
  },
  methods: {
    loadInternalStates() {
      this.loading = true;
      generalService.setSection(ConstantSections.SECTION_INTERNAL_STATES);
      
      generalService
        .filter()
        .then((response) => {
          if (response.status) {
            this.internal_states = response.result;
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((e) => {
          console.log("Error loading internal states", e);
          this.$toast.error("Error al cargar estados internos", "Error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    confirmChange() {
      if (!this.selectedState || !this.productionOrder) {
        return;
      }

      const stateId = this.selectedState.id || this.selectedState;

      this.saving = true;
      
      productionOrderService
        .changeInternalState({
          production_order_id: this.productionOrder.id,
          internal_state_id: stateId,
          observaciones: this.observaciones,
        })
        .then((response) => {
          if (response.status) {
            this.$toast.success(response.msg, "OK");
            this.$emit("updated");
            this.closeDialog();
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((e) => {
          console.log("Error changing internal state", e);
          this.$toast.error("Error al cambiar estado interno", "Error");
        })
        .finally(() => {
          this.saving = false;
        });
    },
    closeDialog() {
      this.dialogVisible = false;
      this.selectedState = null;
      this.observaciones = null;
      this.$emit("updateDialog", false);
    },
  },
};
</script>

<style scoped>
</style>
